import {Swiper} from 'swiper'
import {breakpointDown} from "../helpers/breakpoints";
import gsap, { Power2, Sine, Power1 } from 'gsap'
import {loadBlockLazyImages} from "../helpers/lazy-load";
import {loadElementLottie} from "../helpers/lottie";



/**
 * variable localize_script.admin_ajax - comes from WP setup
 * Required: jquery
 * variable canLoad - waits till ajax action is finished
 * to work MasonryGrid add class js-masonry-grid-el to post columns and set true attribute data-masonry-grid
 *
 * Usage:
 */
export class LoadMore {

  constructor (loadMoreBlock) {

    this.block = loadMoreBlock
    this.container = this.block.find('.js-load-more-container')
    this.button = this.block.find('.js-load-more-button')
    this.buttonBlock = this.block.find('.js-load-more-button-block')
    this.changeCategoryButtons = this.block.find('.js-filter-button')

    this.progressbarTotal = this.block.find('.js-total-posts-count')
    this.progressbarLoaded = this.block.find('.js-loaded-posts-count')
    this.progressbarProgress = this.block.find('.js-loaded-posts-progress')
    this.loader = this.block.find('.js-loader')

    this.useMasonryGrid = this.block.attr('data-masonry-grid')
    this.masonryGrid = ''
    this.action = this.block.attr('data-action')
    this.page = parseInt(this.block.attr('data-page'))
    this.totalPosts = parseInt(this.block.attr('data-total-posts'))
    this.perPage = parseInt(this.block.attr('data-per-page'))
    this.loadedPosts = parseInt(this.block.attr('data-loaded-posts'))
    this.cardTemplate = this.block.attr('data-card-template')
    this.cardContainerClass = this.block.attr('data-card-container-class')
    this.postType = this.block.attr('data-post-type')
    this.taxonomy = this.block.attr('data-taxonomy')
    this.activeTermIdString = this.block.attr('data-active-term-id-arr')

    this.activeTermIdArr = this.activeTermIdString.length ? this.activeTermIdString.split(',') : [];

    this.canLoad = true
    this.totalPages = Math.ceil(this.totalPosts / this.perPage)

    this.updateLoadMore()

    let self = this

    // init masonry grid if enabled
    if (this.useMasonryGrid){
      //this.masonryGrid = new MasonryGrid(this.container)
    }

    // load more button click event
    if (this.button.length)
      this.button.click( () => self.nextPage() );

    // change category button click event
    this.changeCategoryButtons.change(()=> self.changeCategory())


    // uncheck active category
    $('.filter-btn label').click(function(e){
      if ($(this).closest('.filter-btn').find('input').is(':checked')) {
        e.preventDefault()
        //$('.js-filter-button[value=""]').prop('checked', true)
        $('.js-filter-button[value=""]').click()
      }
    })

    // button label click
    $('.element-checkbox label').click(function(e){
      let checkedCount = 0

      if ($(this).closest('.element-checkbox').find('input').is(':checked') && checkedCount <= 1) {
        e.preventDefault()
      }
    })

  }

  nextPage() {

    this.loadPage(this.page + 1)

  }

  changeCategory() {
    let self = this
    self.activeTermIdArr = []

    $('input.js-filter-button:checked').each(function () {
      self.activeTermIdArr.push( $(this).val() );
    })

    this.loadPage(1, 1)

  }


  loadPage(page, change_category = 0) {
    const self = this

    if(!self.canLoad) return false
    if(page > self.totalPages) return false

    this.button.hide()
    this.loader.show()

    self.page = page

    $.ajax({
      type: 'GET',
      url: localize_script.admin_ajax,
      data: {
        action: self.action,
        offset: (self.page - 1) * self.perPage,
        perPage: self.perPage,
        cardTemplate: self.cardTemplate,
        cardContainerClass: self.cardContainerClass,
        postType: self.postType,
        taxonomy: self.taxonomy,
        activeTermIdString: self.activeTermIdArr.toString(),
      },
      success: function (response) {
        self.loader.hide()
        self.button.show()

        let responseHtml = $(response.html)
        loadBlockLazyImages(responseHtml)
        loadElementLottie(responseHtml.find('.js-load-lottie'))

        if (change_category){
          //self.masonryGrid.destroy()
          self.container.html(responseHtml)
          //self.masonryGrid.init()

        } else {

          self.container.append(responseHtml)

          if (self.useMasonryGrid){
            //self.masonryGrid.append(responseHtml)
          }

        }

        // animate in screen
        responseHtml.find('.js-fade-when-in-screen').each(function(){
            gsap.to(this, { y: 0, opacity: 1, delay: 0.1, duration: 0.5, ease: Sine.easeIn })
        })


        self.totalPages = Math.ceil(response.totalPosts / self.perPage)
        self.totalPosts = response.totalPosts
        self.loadedPosts = ((self.page - 1) * self.perPage) + response.loadedPosts

        self.updateData()

        self.updateLoadMore()

        self.updateUrl()

        self.canLoad = true
      }
    })

  }

  updateData() {
    this.block.attr('data-page', this.page)
    this.block.attr('data-total-posts', this.totalPosts)
    this.block.attr('data-term-id', this.activeTermIdArr)
    this.block.attr('data-loaded-posts', this.loadedPosts)
  }

  updateLoadMore(){
    let progress = 100 / this.totalPosts * this.loadedPosts

    this.progressbarTotal.text(this.totalPosts)
    this.progressbarLoaded.text(this.loadedPosts)
    this.progressbarProgress.css('width', progress + '%')

    if (this.perPage >= this.totalPosts){
      this.buttonBlock.hide()
    } else {
      this.buttonBlock.show()
    }

    if(this.page >= this.totalPages) {
      this.button.hide()
    } else {
      this.button.show()
    }
  }


  updateUrl() {

    if (window.history && window.history.pushState) {
      let curUrl = window.location.href.split(/[?#]/)[0]
      let newUrlData = '?lpp=' + this.page;
      if (this.activeTermIdArr) newUrlData += '&category=' + this.activeTermIdArr.toString()
      //if (this.activeSubTermIdArr) newUrlData += '&sub-category=' + this.activeSubTermIdArr.toString()

      history.pushState({}, null, curUrl + newUrlData)
    }

  }

} //-- End Load More Class ---






function initLoadMoreBlock($loadMoreBlock)
{

  if ($loadMoreBlock.length){
    const eventsLoadMore = new LoadMore($loadMoreBlock)
  }


  //-- Filter buttons slider
  $loadMoreBlock.find('.js-resp-cats-swiper').each((i, el)=> {

    if (breakpointDown('xl')) {

      // animate  when in screen
      let swiperLastEl = $(el).find('.swiper-slide').last()
      if (swiperLastEl.offset().left + swiperLastEl.width() > window.innerWidth - 20) {

        let swiper = new Swiper(el, {
          slidesPerView: 'auto',
        });

        ScrollTrigger.create({
          trigger: el,
          start: "top bottom", // el top, screen bottom
          once: true,
          onEnter: () => {
            $(el).find('.swiper-wrapper').delay(400).animate({ left: '-80px' }, 600,
              function () {
                $(this).animate({ left: 0 }, 600)
              })
          }
        });

      }

    }

  }) // -- End Filter Buttons Slider ----


}

initLoadMoreBlock($('.js-load-more-block'))
